import React from "react";
import { Breadcrumbs, Button } from "@material-ui/core";
import { PersonAdd, SearchSharp } from "@material-ui/icons";
import { MENU_RECLAMOS } from "../../../../../utils/constants";
import { validarSoloUnPermiso } from "../../../../../helpers/permisos";
import { useSelector } from "react-redux";
import { RECLAMOS_PERMISOS } from "../../../../../utils/permisos";


const style = {
  root: {
    flexGrow: 1,
  },
};

export const ReclamosBreadcrumb = (props) => {
  const { setActiveBreadcrumb, activeBreadcrumb, permisoIngresoSolicitudes } = props;
  const { permisos: permisosUser } = useSelector((state) => state.auth);


  let rolIngresoBandejaAfiliado = validarSoloUnPermiso(permisosUser,
    RECLAMOS_PERMISOS.BANDEJA_AFILIADO
  );

  let rolIngresoBandejaEfector = validarSoloUnPermiso(permisosUser,
    RECLAMOS_PERMISOS.BANDEJA_EFECTOR
  );

  let rolReclamosAdministrador = validarSoloUnPermiso(permisosUser,
    RECLAMOS_PERMISOS.ADMIN
  );

  let rolReclamosExternos = validarSoloUnPermiso(permisosUser,
    RECLAMOS_PERMISOS.BANDEJA_EXTERNAS
  );



  return (
    <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
      {permisoIngresoSolicitudes &&
        <Button
          color={
            activeBreadcrumb === MENU_RECLAMOS.INGRESO ? "default" : "inherit"
          }
          onClick={(e) => {
            setActiveBreadcrumb(MENU_RECLAMOS.INGRESO);
          }}
        >
          <PersonAdd className={style.icon} />
          Ingreso
        </Button>
      }

      {permisoIngresoSolicitudes && rolReclamosAdministrador &&
        <Button
          color={
            activeBreadcrumb === MENU_RECLAMOS.ENVIADOS ? "default" : "inherit"
          }
          onClick={(e) => {
            setActiveBreadcrumb(MENU_RECLAMOS.ENVIADOS);
          }}
        >
          <SearchSharp className={style.icon} />
          Casos Enviados
        </Button>
      }

      {
        permisoIngresoSolicitudes && rolIngresoBandejaAfiliado &&
        <Button
          color="inherit"
          onClick={(e) => {
            setActiveBreadcrumb(MENU_RECLAMOS.CONSULTA);
          }}
        >
          <SearchSharp className={style.icon} />
          Gestión beneficiarios
        </Button>
      }

      {
        permisoIngresoSolicitudes && rolIngresoBandejaEfector &&
        <Button
          color="inherit"
          onClick={(e) => {
            setActiveBreadcrumb(MENU_RECLAMOS.GESTION_EFECTOR);
          }}
        >
          <SearchSharp className={style.icon} />
          Gestión efectores
        </Button>
      }

{
        permisoIngresoSolicitudes && rolReclamosExternos &&
        <Button
          color="inherit"
          onClick={(e) => {
            setActiveBreadcrumb(MENU_RECLAMOS.GESTION_EXTERNOS);
          }}
        >
          <SearchSharp className={style.icon} />
          Gestión externos
        </Button>
      }
    </Breadcrumbs>
  );
};
